import { render, staticRenderFns } from "./passAndSafety.vue?vue&type=template&id=b8f86368&scoped=true&lang=pug&"
import script from "./passAndSafety.vue?vue&type=script&setup=true&lang=js&"
export * from "./passAndSafety.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./passAndSafety.vue?vue&type=style&index=0&id=b8f86368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f86368",
  null
  
)

export default component.exports